// Single source of truth for color tokens. Extracted verbatim from the
// `:root` block in classroom-morning/styles/main.css. Never hardcode hex
// literals elsewhere — always reference these tokens.

export const colors = {
  /** Amber accent — buttons, highlights, inner card borders. */
  accent: '#e89b4c',
  /** Cream feature-card surface. */
  cardBg: '#f5f4ed',
  /** Deep near-black behind everything. */
  bgDark: '#0b0f12',
  /** Primary text on cream/light surfaces. */
  textPrimary: '#1e2a22',
  /** Classroom-blue secondary accent — paired with cream + amber for
   *  teaching surfaces (e.g. "Today is / Yesterday was / Tomorrow is"
   *  in the Calendar day-detail popup). */
  chalkboardBlue: '#0F869B',
  /** Classroom-green secondary accent — pairs with chalkboardBlue for
   *  side-by-side "Yesterday was / Tomorrow is" boxes. */
  chalkboardGreen: '#15BD6C',
} as const;

export type ColorToken = keyof typeof colors;
